import server from "@/utils/request";


// 发请求的操作封装成函数  mock
// 获取配置
export function getConfig(params) {
    return server({
        method: "GET",
        url: "/api/website/getConfig",
        params,
    })
}
// 获取栏目列表（树形二级）
export function getCategoryList(params) {
    return server({
        method: "GET",
        url: "/api/website/categoryList",
        params,
    })
}

// 根据栏目 id 获取栏目数据（首页等）
export function getCategoryData(params) {
    return server({
        method: "GET",
        url: "/api/website/getCategoryData",
        params,
    })
}

// 提交留言（form-data，必填参数 demands）
export function leaveMessage(demands) {
    const formData = new FormData();
    formData.append("demands", demands);
    return server({
        method: "POST",
        url: "/api/website/leaveMessage",
        data: formData,
    });
}